"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignPlanIdParamsSchema = exports.CampaignTransactionIdParamsSchema = exports.TeamOrderIdParamsSchema = exports.CampaignChannelAllocationIdParamsSchema = void 0;
const core_1 = require("../../../core");
exports.CampaignChannelAllocationIdParamsSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    allocationId: core_1.IdSchema,
}, {
    title: "Campaign and Allocation",
    description: "Combined Campaign and Allocation Id in a query parameter",
});
exports.TeamOrderIdParamsSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    orderId: core_1.IdSchema,
}, {
    title: "Team and Order",
    description: "Combined Team and Order Id in a query parameter",
});
exports.CampaignTransactionIdParamsSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    transactionId: core_1.IdSchema,
}, {
    title: "Campaign and Allocation",
    description: "Combined Campaign and Transaction Id in a query parameter",
});
exports.CampaignPlanIdParamsSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    planId: core_1.IdSchema,
}, {
    title: "Campaign and Plan",
    description: "Combined Campaign and Plan Id in a query parameter",
});
